import React from 'react';
import FormNewEstablishment from './FormNewEstablishment';

import { InfoDialogModal } from '@shared/components/Dialogs';

const HeaderModals = ({
  showModal,
  setShowModal,
  pageConfiguration,
  bspAndGitDollarValue,
  isRegisteredModal,
  setIsRegisteredModal,
}) => {
  return (
    <>
      {showModal && (
        <FormNewEstablishment
          {...{
            showModal,
            setShowModal,
            pageConfiguration,
            bspAndGitDollarValue,
            setIsRegisteredModal,
          }}
        />
      )}

      {isRegisteredModal && (
        <InfoDialogModal
          isOpen={isRegisteredModal}
          onClose={() => setIsRegisteredModal(false)}
          title="Registro de alojamiento"
          text="Gracias por registrarse, en breve nos contactaremos con usted"
        />
      )}
    </>
  );
};

export default HeaderModals;
